<nz-select
nzShowSearch
nzAllowClear
[nzDropdownStyle]="{ 'max-height': '300px' }"
nzPlaceHolder=""
(ngModelChange)="modelChange($event)"
[(ngModel)]="defaultValue">
    <nz-option *ngFor="let item of dataSource" nzAllowClear [nzLabel]="item.OrganizeName"
        [nzValue]="item.OrganizeId">
    </nz-option>
</nz-select>
